/**
 * Internal dependencies
 */
import getAllReports from'./get-all-reports';

export default (state, query, category) => {
	let reports = getAllReports(state);
	return reports;
};